export function SET_ROUTE_FROM({ commit }, routeName) {
	commit('SAVE_ROUTE_FROM', routeName)
}

export function SET_LOADING_ACTIVITIES({ commit }, value) {
	commit('SAVE_LOADING_ACTIVITIES', value)
}
